import { Typewriter } from './Typewriter';
import { KWELLO_ICON, KwelloSvgIcon } from '../../../components/icon/KwelloSvgIcon';

interface ServerErrorCardProps {
  text?: string;
}

export const ServerErrorCard = ({ text }: ServerErrorCardProps) => {
  return (
    <div className="server-error">
      <KwelloSvgIcon icon={KWELLO_ICON.WARNING_ICON} />
      <div className="text-values">
        <Typewriter
          loopDelay={0}
          textValues={[
            text ??
              "I'm sorry, that didn't work. Please refresh your page and try again. If the issue persists please contact support",
          ]}
        />
      </div>
    </div>
  );
};
